import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export type PriceType = Record<
  string,
  {
    price: string;
    price24h: string;
  }
>;

export interface Data24hBuyApi {
  time: number;
  value: number;
  pairIndex: number;
}
interface PriceStore {
  data: PriceType;
  setData: (newPrice: [string, string, string]) => void;
  setPrice24hChangePair: (data: Record<number, Data24hBuyApi>, newPrice: [string, string, string]) => void;
}

export const usePrice = create(
  subscribeWithSelector(
    immer<PriceStore>((set) => ({
      data: {},
      setData: (data) =>
        set((state) => {
          if (!state.data[data[0]]) {
            state.data[data[0]] = { price: "", price24h: "" };
          }

          if (data[1]) {
            state.data[data[0]].price = data[1];
          }

          if (data[2]) {
            state.data[data[0]].price24h = data[2];
          }
        }),

      setPrice24hChangePair: (data, newPrice) =>
        set((state) => {
          if (!newPrice[1]) {
            state.data[newPrice[0]] = { price: "", price24h: "" };
          }

          if (newPrice[1] && data[Number(newPrice[0])]?.value && state.data[newPrice[0]]?.price) {
            const current = Number(newPrice[1]);
            const previous = data[Number(newPrice[0])].value;
            const percent = ((current - previous) / previous) * 100;

            state.data[newPrice[0]].price24h = percent.toString();
          }
        }),
    }))
  )
);
